import { BetaFeaturesEnum, GetBetaFeaturesResponse, } from '@src/api/beta-features/get-beta-features';

export function hasAirMaxOptInEnabled(data: GetBetaFeaturesResponse[]) {
  if (data.length) {
    const airMaxOptInEnabled = data.find(
      ([key]) => key === BetaFeaturesEnum.AIR_MAX_BETA,
    )?.[1];
    return !!airMaxOptInEnabled;
  }

  return false;
}
